import { connect } from 'react-redux';
import ContainerActionsBar from './ContainerActionsBar';
import { getInvalidItemsCount } from '../../../../selectors/getInvalidItemsCount';
import { getItemsForEstimate } from '../../../../selectors/getItemsForEstimate';
import cookiesFactory from '../../../../../../base/cookies-factory';

const mapStateToProps = ({ estimateBuilder }, ownProps) => {
  const { entities, uiState } = estimateBuilder;
  const hasCustomProduct = getItemsForEstimate(entities, uiState.selectedEstimate)
    .filter(givenItem => givenItem.containerId === ownProps.containerId && givenItem.itemProduct)
    .reduce((acc, givenItem) => acc || givenItem.itemProduct.productType === 'Custom', false);

  const isInternalUser = cookiesFactory.isInternalUser();

  return {
    invalidItemsCount: getInvalidItemsCount(entities, uiState.selectedEstimate),
    disableDuplicate: hasCustomProduct && !isInternalUser,
  };
};

export default connect(mapStateToProps)(ContainerActionsBar);
